import styled from 'styled-components';

export const Container = styled.img`
  height: 36px;
  width: 36px;
  border-radius: 100px;
  cursor: pointer;
`;
